<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>Edit {{ voucherTypeId }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-if="voucherTypeId" bottom left>
        <v-btn icon slot="activator">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click.stop="dialogDelete = true">
            <v-list-tile-title>Delete</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-form ref="form" v-model="frmValid">
        <v-container fluid grid-list-lg class="pa-3">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="txtName"
                :rules="[v => !!v || 'Name is required']"
                :counter="255"
                label="Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="txtMaxUsageLimit"
                :rules="[v => v > 0 || 'Should be above 0', v => v <= 100 || 'Should be 100 or below', v => /^[-|+]?\d*$/.test(v) || 'Must be integer']"
                type="number"
                label="Max usage limit"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="txtMaxDiscountPercentage"
                :rules="[v => v >= 0 || 'Should be >= 0', v => v <= 100 || 'Should be 100 or below', v => /^[-|+]?\d*$/.test(v) || 'Must be integer']"
                type="number"
                label="Max discount percentage"
                suffix="%"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4 sm3 md2>
              <v-select
                v-model="cboCurrencyCode"
                :items="currencies"
                item-text="currencyCode"
                item-value="currencyCode"
                :rules="[v => !!v || 'Please select currency']"
                label="Currency"
                required
              ></v-select>
            </v-flex>
            <v-flex xs8 sm9 md10>
              <v-text-field
                v-model="txtMaxDiscountAmount"
                :rules="[v => v >= 0 || 'Should be >= 0', v => /^[-|+]?\d*$/.test(v) || 'Must be integer']"
                label="Max Discount Amount"
                type="number"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="txtMinimumPurchase"
                :rules="[v => v >= 0 || 'Should be >= 0', v => /^[-|+]?\d*$/.test(v) || 'Must be integer']"
                label="Minimum purchase"
                type="number"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="txtExpiryInDays"
                :rules="[v => v > 0 || 'Should be > 0', v => v <= 365 || 'Should be 365 or below', v => /^[-|+]?\d*$/.test(v) || 'Must be integer']"
                label="Expiry in days"
                type="number"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-switch
                v-model="switchFirstPurchaseOnly"
                color="primary"
                label="First purchase only"
              ></v-switch>
            </v-flex>
            <v-flex xs12>
              <v-switch
                v-model="switchMixable"
                color="primary"
                label="Mixable"
              ></v-switch>
            </v-flex>
            <v-flex xs4>
              <v-select
                v-model="cboCategoryFilter"
                :items="categoryFilters"
                label="Category Filter"
              ></v-select>
            </v-flex>
            <v-flex xs8>
              <div v-if="cboCategoryFilter !== ''">
                <div class="caption">Categories</div>
                <v-chip v-for="category in cboCategories" :key="category.categoryId" close @input="removeCategory(category)">{{ (category.categoryName ? category.categoryName : category.name) }}</v-chip>
                <v-btn
                  outline
                  icon
                  small
                  class="ml-2 mr-0 mt-0 mb-0"
                  @click="showAddCategoryDialog"
                >
                  <v-icon small>add</v-icon>
                </v-btn>
              </div>
              <!--<v-combobox
                v-if="cboCategoryFilter !== ''"
                v-model="cboCategories"
                :items="categories"
                item-text="name"
                item-value="categoryId"
                label="Categories"
                :rules="[v => !!v || 'Please select category']"
                hide-details
                chips
                multiple
                required
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    @input="removeCategory(data.item)"
                  >
                    <strong>{{ (data.item.categoryName ? data.item.categoryName : data.item.name) }}</strong>
                  </v-chip>
                </template>
              </v-combobox>-->
            </v-flex>
            <v-flex xs4>
              <v-select
                v-model="cboProductFilter"
                :items="productFilters"
                label="Product Filter"
              ></v-select>
            </v-flex>
            <v-flex xs8>
              <div v-if="cboProductFilter !== ''">
                <div class="caption">Products</div>
                <v-chip v-for="product in cboProducts" :key="product.productId" close @input="removeProduct(product.productId)">{{ product.productName }}</v-chip>
                <v-btn
                  outline
                  icon
                  small
                  class="ml-2 mr-0 mt-0 mb-0"
                  @click="showAddProductDialog"
                >
                  <v-icon small>add</v-icon>
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs12 class="mt-5">
              <v-btn
                large
                block
                color="primary"
                :disabled="!frmValid"
                @click="submit"
              >
                Save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-dialog v-model="dialogAddCategory" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Add Category</v-card-title>
          <v-card-text>
            <v-form ref="frmAddCategory" v-model="frmAddCategoryValid" @submit.prevent="">
              <v-text-field
                v-model="txtAddCategoryId"
                :rules="[v => !!v || 'Category ID is required']"
                label="Category ID"
                @keyup.enter="addCategory"
                required
              ></v-text-field>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmAddCategoryValid"
                @click="addCategory"
              >
                Add Category
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAddProduct" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Add Product</v-card-title>
          <v-card-text>
            <v-form ref="frmAddProduct" v-model="frmAddProductValid" @submit.prevent="">
              <v-text-field
                v-model="txtAddProductId"
                :rules="[v => !!v || 'Product ID is required']"
                label="Product ID"
                @keyup.enter="addProduct"
                required
              ></v-text-field>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmAddProductValid"
                @click="addProduct"
              >
                Add Product
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogDelete"
        max-width="290"
      >
        <v-card>
          <v-card-title class="title">Confirm to delete this voucher?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              flat="flat"
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="deleteVoucher()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  props: [
    'voucherTypeId'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      frmValid: true,
      txtName: '',
      txtMaxUsageLimit: 1,
      cboCurrencyCode: '',
      txtMaxDiscountPercentage: 0,
      txtMaxDiscountAmount: 0,
      txtMinimumPurchase: 0,
      txtExpiryInDays: 30,
      switchFirstPurchaseOnly: false,
      switchMixable: true,
      categoryFilters: ['', 'whitelist', 'blacklist'],
      cboCategoryFilter: '',
      categories: [],
      cboCategories: [],
      productFilters: ['', 'whitelist', 'blacklist'],
      cboProductFilter: '',
      cboProducts: [],
      dialogAddProduct: false,
      frmAddProductValid: false,
      txtAddProductId: '',
      dialogAddCategory: false,
      frmAddCategoryValid: false,
      txtAddCategoryId: '',
      currencies: [],
      dialogDelete: false
    }
  },

  mounted () {
    this.cboCurrencyCode = this.def.currency.currencyCode

    this.openDrawerForDesktop()
    this.getCategories()
    this.getCurrencies()
    this.getVoucherType(this.voucherTypeId)
  },

  methods: {
    showAddProductDialog: function () {
      this.frmAddProductValid = false
      this.txtAddProductId = ''
      this.dialogAddProduct = true
    },
    addProduct () {
      if (this.$refs.frmAddProduct.validate()) {
        var _this = this
        const pos = _this.cboProducts.map(e => e.productId).indexOf(_this.txtAddProductId)
        if (pos === -1) {
          _this.loading = true
          axios.get(process.env.VUE_APP_API_ROOT + '/v1/product/' + _this.txtAddProductId)
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                const item = {
                  'productId': resp.data.data.productId,
                  'productName': resp.data.data.name
                }
                _this.cboProducts.push(item)
                _this.dialogAddProduct = false
              } else {
                window.alert('Invalid product: ' + resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                }
                _this.loading = false
              }
            })
        } else {
          // product already in the list
          _this.dialogAddProduct = false
        }
      }
    },
    removeProduct: function (productId) {
      var _this = this
      const pos = _this.cboProducts.map(e => e.productId).indexOf(productId)
      console.log('pos: ' + pos)
      _this.cboProducts.splice(pos, 1)
      _this.cboProducts = [..._this.cboProducts]
    },
    deleteVoucher: function () {
      this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/voucher/' + this.voucherTypeId)
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            router.push('/vouchers')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    showAddCategoryDialog: function () {
      this.frmAddCategoryValid = false
      this.txtAddCategoryId = ''
      this.dialogAddCategory = true
    },
    addCategory () {
      if (this.$refs.frmAddCategory.validate()) {
        var _this = this
        const pos = _this.cboCategories.map(e => e.categoryId).indexOf(_this.txtAddCategoryId)
        if (pos === -1) {
          _this.loading = true
          axios.get(process.env.VUE_APP_API_ROOT + '/v1/category/' + _this.txtAddCategoryId)
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                const item = resp.data.data
                _this.cboCategories.push(item)
                _this.dialogAddCategory = false
              } else {
                window.alert('Invalid category: ' + resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                }
                _this.loading = false
              }
            })
        } else {
          // product already in the list
          _this.dialogAddCategory = false
        }
      }
    },
    removeCategory: function (item) {
      this.cboCategories.splice(this.cboCategories.indexOf(item), 1)
      this.cboCategories = [...this.cboCategories]
    },
    getCurrencies: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.currencies = resp.data.data
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    getCategories: function () {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/categories')
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.categories = resp.data.data
            } else {
              console.log('unable to load categories: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },
    getVoucherType: function (voucherTypeId) {
      if (voucherTypeId) {
        this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/voucher/' + voucherTypeId)
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.txtName = resp.data.data.name
              this.txtMaxUsageLimit = resp.data.data.maxUsageLimit
              this.cboCurrencyCode = resp.data.data.currencyCode
              this.txtMaxDiscountPercentage = resp.data.data.maxDiscountPercentage
              this.txtMaxDiscountAmount = resp.data.data.maxDiscountAmount
              this.txtMinimumPurchase = resp.data.data.minimumPurchase
              this.txtExpiryInDays = resp.data.data.expiryInDays
              this.switchFirstPurchaseOnly = (resp.data.data.isFirstPurchaseOnly === '1')
              this.switchMixable = (resp.data.data.isMixable === '1')
              this.cboCategoryFilter = resp.data.data.categoryFilter
              this.cboCategories = []
              if (this.cboCategoryFilter === 'whitelist') {
                this.cboCategories = resp.data.data.whitelistCategories
              } else if (this.cboCategoryFilter === 'blacklist') {
                this.cboCategories = resp.data.data.blacklistCategories
              }
              this.cboProductFilter = resp.data.data.productFilter
              this.cboProducts = []
              if (this.cboProductFilter === 'whitelist') {
                this.cboProducts = resp.data.data.whitelistProducts
              } else if (this.cboProductFilter === 'blacklist') {
                this.cboProducts = resp.data.data.blacklistProducts
              }
            } else {
              console.log('unable to load voucher details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    submit () {
      if (this.$refs.form.validate()) {
        if (this.cboCategoryFilter !== '' && this.cboCategories.length === 0) {
          window.alert('Category is required')
          return false
        }

        var i
        var data = {
          name: this.txtName,
          maxUsageLimit: this.txtMaxUsageLimit,
          currencyCode: this.cboCurrencyCode,
          maxDiscountPercentage: this.txtMaxDiscountPercentage,
          maxDiscountAmount: this.txtMaxDiscountAmount,
          minimumPurchase: this.txtMinimumPurchase,
          expiryInDays: this.txtExpiryInDays,
          isFirstPurchaseOnly: this.switchFirstPurchaseOnly,
          isMixable: this.switchMixable,
          categoryFilter: this.cboCategoryFilter,
          productFilter: this.cboProductFilter
        }

        if (this.cboCategoryFilter === 'whitelist') {
          var whitelistCategoryIds = []
          for (i in this.cboCategories) {
            whitelistCategoryIds.push(this.cboCategories[i].categoryId)
          }
          data['whitelistCategoryIds'] = whitelistCategoryIds
        } else if (this.cboCategoryFilter === 'blacklist') {
          var blacklistCategoryIds = []
          for (i in this.cboCategories) {
            blacklistCategoryIds.push(this.cboCategories[i].categoryId)
          }
          data['blacklistCategoryIds'] = blacklistCategoryIds
        }

        if (this.cboProductFilter === 'whitelist') {
          var whitelistProductIds = []
          for (i in this.cboProducts) {
            whitelistProductIds.push(this.cboProducts[i].productId)
          }
          data['whitelistProductIds'] = whitelistProductIds
        } else if (this.cboProductFilter === 'blacklist') {
          var blacklistProductIds = []
          for (i in this.cboProducts) {
            blacklistProductIds.push(this.cboProducts[i].productId)
          }
          data['blacklistProductIds'] = blacklistProductIds
        }

        this.loading = true
        if (this.voucherTypeId) {
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/voucher/' + this.voucherTypeId, data, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/vouchers')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        } else {
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/voucher', data, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/vouchers')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        }
      }
    }
  }
}
</script>
